import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import { Status } from '@ui/atoms/Status';
import { useIpaTechAssessments } from '../../hooks/useIpaTechAssessments';
import { TECHNICIAN_RATING_STATUS_COLOR, technicianRatingLabel } from '../../utils/technicianRatingDisplay';
import './TechnicianRowStyles.scss';
const NS = 'features.iim_review.technician_row';
export const POORLY_RATED_RATINGS = ['needs_review', 'needs_coaching'];
function TechnicianRow({ technicianAssessment }) {
    return (React.createElement("div", { className: "technician-row" },
        React.createElement("span", { className: "technician-row__content" },
            React.createElement(Text, { variant: "x-small", as: "span", className: "technician-row__title" }, translate('title', { namespace: NS, defaultValue: 'Technician performance on this inspection' })),
            React.createElement(Status, { label: technicianRatingLabel(technicianAssessment.rating), color: TECHNICIAN_RATING_STATUS_COLOR[technicianAssessment.rating] }))));
}
export function TechnicianRowList({ inspectionId }) {
    const { data: assessments = [], isError } = useIpaTechAssessments(inspectionId);
    if (isError)
        return null;
    const poorlyRated = assessments.filter((a) => POORLY_RATED_RATINGS.includes(a.rating));
    if (poorlyRated.length === 0)
        return null;
    return (React.createElement(React.Fragment, null, poorlyRated.map((assessment) => (React.createElement(TechnicianRow, { key: assessment.id, technicianAssessment: assessment })))));
}
export default TechnicianRow;
